(() => {
  'use strict';
  function init(root) {
    if (root.dataset.whReady) return;
    const q = s => root.querySelector(s), all = s => [...root.querySelectorAll(s)];
    const form = document.getElementById(root.dataset.formId);
    const gate = q('[data-wh-native]'), error = q('[data-wh-error]');
    let variants, rules;
    try {
      variants = JSON.parse(q('[data-wh-variants]').textContent);
      rules = JSON.parse(q('[data-wh-contract]').textContent);
      if (!form || !gate || !Array.isArray(variants) || variants.length !== rules.ids.length ||
          !variants.every(v => rules.ids.includes(String(v.id)) && (!rules.skus || String(rules.skus[String(v.id)] || '') === String(v.sku || '')))) throw Error('identity');
    } catch (_) {
      if (gate) gate.disabled = true;
      if (error) { error.hidden = false; error.textContent = 'This configuration needs review. Please contact our team before ordering.'; }
      return;
    }
    root.dataset.whReady = 'true';
    const id = form.querySelector('[name=id]'), submit = form.querySelector('[type=submit]');
    const qty = q('[data-wh-quantity]'), nativeSelect = q('[data-wh-variant]');
    const sticky = q('[data-wh-sticky]'), stickyButton = q('[data-wh-sticky-button]');
    let current = variants.find(v => String(v.id) === id.value);
    let valid = false;
    const busy = () => submit.classList.contains('loading') || submit.getAttribute('aria-disabled') === 'true';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
    const permitted = v => Boolean(v && rules.ids.includes(String(v.id)) && v.available);
    function mirror() {
      const blocked = !valid || !permitted(current) || busy();
      stickyButton.disabled = blocked;
      stickyButton.textContent = busy() ? 'Updating cart…' : permitted(current) ? 'Add to cart' : 'Unavailable';
      qty.disabled = busy();
      if (nativeSelect) nativeSelect.disabled = busy();
      all('[data-wh-method]').forEach(r => { r.disabled = busy(); });
    }
    function update() {
      const rule = current?.quantityRule;
      qty.min = String(rule?.min || 1); qty.step = String(rule?.increment || 1);
      if (rule?.max != null) qty.max = String(rule.max); else qty.removeAttribute('max');
      const count = Number(qty.value);
      valid = Boolean(current && rules.ids.includes(String(current.id)) && Number.isInteger(count) &&
        count >= Number(qty.min) && (!qty.max || count <= Number(qty.max)) && (count - Number(qty.min)) % Number(qty.step) === 0);
      const allowed = permitted(current);
      gate.disabled = !valid || !allowed;
      if (!current) {
        error.hidden = false; error.textContent = 'Choose a verified configuration before adding it to your cart.'; mirror(); return;
      }
      id.value = String(current.id); id.disabled = false;
      id.dispatchEvent(new Event('change', { bubbles: true }));
      const price = q(`template[data-wh-price="${current.id}"]`);
      if (price) q('[data-wh-price]').innerHTML = price.innerHTML;
      const installment = document.getElementById(root.dataset.formId.replace('product-form-', 'product-form-installment-'));
      const installmentId = installment?.querySelector('[name=id]');
      if (installmentId) { installmentId.value = String(current.id); installmentId.dispatchEvent(new Event('change', { bubbles: true })); }
      q('[data-wh-summary]').textContent = current.title === 'Default Title' ? (current.sku || 'Selected equipment configuration') : current.title;
      q('[data-wh-sku]').textContent = current.sku || 'See the model identity above';
      q('[data-wh-total]').textContent = valid ? money(current.price * count) : 'Check quantity';
      q('[data-wh-sticky-price]').textContent = money(current.price);
      q('[data-wh-mobile-price]').textContent = money(current.price);
      q('[data-wh-availability]').textContent = allowed ? 'Available to order · final availability confirmed in cart' : 'This configuration is unavailable. Please contact our team.';
      error.hidden = valid;
      error.textContent = valid ? '' : 'Enter a whole quantity within this configuration’s native quantity rules.';
      if (rules.family === 'hyperheat' || rules.family === 'versapro') {
        const precharged = String(current.id) !== rules.base;
        q('[data-wh-length]').hidden = !precharged;
        if (precharged) nativeSelect.value = String(current.id);
        all('[data-wh-method]').forEach(r => { r.checked = (r.value === 'precharged') === precharged; });
        q('[data-wh-method-note]').textContent = precharged
          ? 'One native equipment-and-line-set configuration. No duplicate line set is added. A pre-charged option does not waive manufacturer installation requirements.'
          : 'Professional copper installation: no additional factory pre-charged line set selected. Follow manufacturer installation requirements.';
      }
      const finance = q('.mpe'); if (finance) finance.dataset.ptPrice = String(current.price / 100);
      q('[data-wh-status]').textContent = `${current.sku || 'Selected equipment'}. ${money(current.price)}. ${allowed ? 'Available to order.' : 'Unavailable.'}`;
      const url = new URL(location.href); url.searchParams.set('variant', String(current.id)); history.replaceState({}, '', url);
      mirror();
    }
    all('[data-wh-method]').forEach(r => r.addEventListener('change', () => {
      current = r.value === 'traditional' ? variants.find(v => String(v.id) === rules.base)
        : variants.find(v => String(v.id) === nativeSelect.value);
      update();
    }));
    nativeSelect?.addEventListener('change', () => { current = variants.find(v => String(v.id) === nativeSelect.value); update(); });
    qty.addEventListener('input', update);
    all('[data-wh-media]').forEach(button => button.addEventListener('click', () => {
      const gallery = q('media-gallery');
      if (typeof gallery?.setActiveMedia !== 'function') {
        error.hidden = false; error.textContent = 'The gallery is still loading. Try again or open the standard product page.'; return;
      }
      gallery.setActiveMedia(button.dataset.whMedia, true);
      all('[data-wh-media]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    // Relay to the existing native form/app handler. No second cart client or payload builder.
    stickyButton.addEventListener('click', () => { if (valid && permitted(current) && !busy()) submit.click(); });
    form.addEventListener('submit', e => {
      if (!valid || !permitted(current) || busy()) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, { capture: true });
    new MutationObserver(mirror).observe(submit, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
      sticky.hidden = entries[0].isIntersecting;
    }, { threshold: 0.2, rootMargin: '0px 0px -100px 0px' }).observe(submit);
    const search = q('[data-wh-search]');
    search?.addEventListener('input', () => {
      let count = 0; all('[data-wh-resource]').forEach(el => { el.hidden = !el.textContent.toLowerCase().includes(search.value.trim().toLowerCase()); if (!el.hidden) count++; });
      q('[data-wh-resource-count]').textContent = `${count} resources${count ? '' : ' — try a different term or contact our team'}`;
    });
    update();
  }
  document.querySelectorAll('[data-whole-home]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-whole-home]').forEach(init));
})();
